import React from "react";
import { Typography, withStyles, Box } from "@material-ui/core";
import PropTypes from "prop-types";
import BookingDetails from "../../bookings/booking_details";
import TransferForm from "./transfer_form";
import ThemeProvider from "components/shared/theme_provider";
import {
  reStyleCalendarHeaders,
  renderCalendarStyles,
  selectedWeeks,
  reInitializeWeekPicker,
  resetCalPlaceholder,
  getDatesByWeekNumber,
} from "./calendar_helpers";
import {
  updateCalendar,
  submitForm,
  getLocationCapacityDetails,
  getActivitySessionCapacityDetails,
  getCapacityTableDetails,
} from "./fetch_actions";
import SingleActionModal from "components/shared/modals/single_action_modal";
import Dialog from "components/shared/auth/dialog";
import OverbookCapacityAlertContainer from "components/portal/transfers/weekly/overbook_capacity_alert_container";
import DialogCloseButton from "components/shared/dialog_close_button";

const styles = (theme) => ({
  header: {
    paddingBottom: 16,
    [theme.breakpoints.down("xs")]: {
      fontSize: 24,
    },
  },
});

class TransfersContainer extends React.Component {
  constructor(props) {
    super(props);

    this.csrf = $("meta[name='csrf-token']").attr("content");
    this.state = {
      selectedActivityID: "",
      calendarErrors: "",
      activityErrors: "",
      datesForCalendarSelect: [],
      showCapacityAlert: false,
      capacityData: [],
      locationCapacityData: [],
      locationCapacityMet: false,
      showSubmitAlert: false,
      disableModalButton: false,
      disableFormButton: false,
      showCapacityTable: false,
      showLoader: false,
    };
  }

  componentDidMount() {
    /* eslint no-undef:0 */
    initPortalV2ObjectPicker();
    renderCalendarStyles();
    reInitializeWeekPicker();
  }

  componentDidUpdate() {
    this.addBlackOutDates();
    this.renderCapacityTable();
    // reInitializeWeekPicker();
  }

  render() {
    const {
      transferData: bookingData,
      classes,
      studentTerminology,
    } = this.props;
    const { activities_for_select: activityOptions } = bookingData;

    return (
      <div className="transfers-container">
        <ThemeProvider>
          <Dialog open={this.state.showCapacityAlert}>
            <DialogCloseButton onClick={this.closeCapacityModal} />
            <OverbookCapacityAlertContainer
              disableModalButton={this.state.disableModalButton}
              completeTransfer={this.completeTransfer}
              cancelTransfer={this.closeCapacityModal}
              locationCapacityMet={this.state.locationCapacityMet}
              capacityData={
                this.state.locationCapacityMet
                  ? this.state.locationCapacityData
                  : this.state.capacityData
              }
            />
          </Dialog>

          <Dialog open={this.state.showSubmitAlert}>
            <DialogCloseButton onClick={this.closeErrorModal} />
            <SingleActionModal
              image="blocks"
              message="Something doesn’t look right…"
              subtext="Try refreshing the page and try again."
              buttonText="Got it"
              onClose={this.closeErrorModal}
            />
          </Dialog>

          <div className="pv40 pl40 mpt25 mpb40 transfer-by-week-text">
            <Typography
              className={classes.header}
              variant="h1"
              color="textPrimary"
            >
              Transfer by Week
            </Typography>
            <Typography variant="body1" color="textPrimary">
              {`Weekly Transfers enable ${studentTerminology} to be transfered within or across
              activities, one week at a time`}
              .
            </Typography>
          </div>
          <Box pr={5} pl={5}>
            <BookingDetails bookingData={bookingData.booking} />
          </Box>
          <TransferForm
            activityOptions={activityOptions}
            updateSelectedActivity={this.updateSelectedActivity}
            cancelTransfer={this.cancelTransfer}
            executeTransfer={this.executeTransfer}
            csrf={this.csrf}
            calendarErrors={this.state.calendarErrors}
            activityErrors={this.state.activityErrors}
            disableFormButton={this.state.disableFormButton}
            capacityData={this.state.capacityData}
            showCapacityTable={this.state.showCapacityTable}
            showLoader={this.state.showLoader}
          />
        </ThemeProvider>
      </div>
    );
  }

  closeErrorModal = () => {
    this.setState({ showSubmitAlert: false });
  };

  closeCapacityModal = () => {
    this.setState({ showCapacityAlert: false });
  };

  // ----------------------- SELECT DROPDOWN -----------------------------------------//

  updateSelectedActivity = (selectedActivityID) => {
    this.clearErrors();
    resetCalPlaceholder();
    updateCalendar(selectedActivityID, (calendarHTML) => {
      this.updateCalendarDates(calendarHTML.calendarData);
      this.setState({ selectedActivityID });
    });
  };

  // -------------------------- ACTIONS-------------------------------------------//

  executeTransfer = () => {
    if (this.validActivityAndSelectedDates()) {
      this.checkLocationCapacity();
    }
  };

  checkLocationCapacity = () => {
    getLocationCapacityDetails(
      this.state.selectedActivityID,
      (locationCapacityDetails) => {
        if (locationCapacityDetails.status == "overbooked") {
          this.setState({
            showCapacityAlert: true,
            locationCapacityMet: true,
            locationCapacityData:
              locationCapacityDetails.location_capacity_data,
          });
        } else {
          this.checkActivitySessionCapacity();
        }
      }
    );
  };

  checkActivitySessionCapacity = () => {
    getActivitySessionCapacityDetails(
      this.state.selectedActivityID,
      (capacityDetails) => {
        if (capacityDetails.status == "overbooked") {
          this.setState({
            showCapacityAlert: true,
            capacityData: capacityDetails.capacity_data,
          });
        } else {
          let selectedDates = capacityDetails.capacity_data.map(
            (detail) => detail.date
          );
          this.completeTransfer(selectedDates, "form");
        }
      }
    );
  };

  completeTransfer = (selectedDates, source) => {
    this.disableTransferButton(source);
    submitForm(this.props.url, this.state, selectedDates, (response) => {
      if (response.ok) {
        window.location = response.url;
      } else {
        this.handleResponseError();
      }
    });
  };

  disableTransferButton = (source) => {
    if (source === "modal") {
      this.setState({ disableModalButton: true });
    }
    if (source === "form") {
      this.setState({ disableFormButton: true });
    }
  };

  handleResponseError = () => {
    this.setState({
      showCapacityAlert: false,
      showSubmitAlert: true,
      disableModalButton: false,
      disableFormButton: false,
    });
  };

  cancelTransfer = () => {
    window.location.href = this.props.cancel_url;
  };

  clearErrors = () => {
    this.setState({ activityErrors: "", calendarErrors: "" });
  };

  // ------------------------- VALIDATIONS -----------------------------------------//

  validActivityAndSelectedDates = () => {
    return this.validSelectedActivity() && this.validSelectedDates();
  };

  validSelectedActivity = () => {
    let activity = parseInt(this.state.selectedActivityID);
    let activities = this.activityOptions();
    let activityDisplayed = parseInt($("#transfer-weekly-hidden-input").val());

    if (activities.includes(activity) && activityDisplayed == activity) {
      this.setState({ activityErrors: "" });
      return true;
    } else {
      this.setState({
        activityErrors: "Select a valid activity",
      });
      return false;
    }
  };

  activityOptions = () => {
    return this.props.transferData.activities_for_select.map(
      (activity) => activity.id
    );
  };

  validSelectedDates = () => {
    if (this.oneWeekSelected()) {
      this.setState({ calendarErrors: "" });
      return true;
    } else {
      this.setState({
        calendarErrors: "Select One Week",
      });
      return false;
    }
  };

  oneWeekSelected = () => {
    return selectedWeeks().length == 1;
  };

  // -------------------------- CALENDAR -------------------------------------------//
  updateCalendarDates = (calendarHTML) => {
    $(".calendar-placement").html(calendarHTML);
    reStyleCalendarHeaders();
  };

  addBlackOutDates = () => {
    if (
      parseInt(this.state.selectedActivityID) ==
      this.props.transferData.current_asg_id
    ) {
      let blackOutNodes = this.props.transferData.same_week_sessions.map(
        (dateString) => {
          return $(`[data-date='${dateString}']`);
        }
      );

      blackOutNodes.map((node) => {
        node
          .children()
          .removeClass("chosen-day specific-day")
          .addClass("black-out");
      });
    }
  };

  renderCapacityTable = () => {
    $(".cal-picker-week:has(.chosen-day)").on("click", (e) => {
      e.preventDefault();
      const weekNumber =
        event.currentTarget.firstChild.firstChild.dataset.weekNum;
      const dates = getDatesByWeekNumber(weekNumber);

      this.setState({ showLoader: true });
      getCapacityTableDetails(
        "/api/v1/portal/weekly_transfers/capacity_details",
        this.state,
        dates,
        (capacityDetails) => {
          this.setState({
            showLoader: false,
            showCapacityTable: true,
            capacityData: capacityDetails.capacity_data,
          });
        }
      );

      $(".capacity-table").show((e) => {
        $(".cal-picker-week").unbind();
      });
    });
  };
}

TransfersContainer.propTypes = {
  url: PropTypes.string.isRequired,
  cancel_url: PropTypes.string.isRequired,
  transferData: PropTypes.object,
  classes: PropTypes.object.isRequired,
  studentTerminology: PropTypes.string.isRequired,
};

export default withStyles(styles)(TransfersContainer);
